import { InjectionToken } from '@angular/core';

import { DefaultProps } from 'tippy.js';

export * from './mat-tooltip.directive';
export const MAT_TOOLTIP_CONFIG = new InjectionToken<DefaultProps>('matTooltipConfig');
